import { ReactNode } from "react";
import { BgColor, BorderColor, TextColor } from "types/global";

type StatusPillProps = {
	backgroundColor: BgColor;
	borderColor?: BorderColor;
	children: ReactNode;
	className?: string;
	rounded?: boolean;
	textColor?: TextColor;
};

export const StatusPill: React.FC<StatusPillProps> = ({
	rounded = true,
	className,
	textColor,
	backgroundColor,
	borderColor,
	children,
}) => {
	return (
		<div
			className={`flex items-center justify-center text-center font-roboto text-[14px] font-medium ${rounded ? "rounded-md" : rounded} p-3 shadow-sm ${textColor} ${backgroundColor} ${borderColor} border-1 border-solid ${className}`}
			style={{
				width: "fit-content",
				height: "24px",
			}}
		>
			{children}
		</div>
	);
};
